<template>
  <misPagos/>
</template>

<script>
  import misPagos from '@/components/mis-pagos/index'
  export default {
    components:{
      misPagos
    }
  }
</script>